import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=3977f1bc&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"
import style0 from "./formBox.vue?vue&type=style&index=0&id=3977f1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3977f1bc",
  null
  
)

export default component.exports